'use strict';
const user = require('../models/user');

const UserModel = user.extend({
    getRole: function () {
        return this.get('role') || 'basic';
    }
});

module.exports = new UserModel();